export default __webpack_public_path__ + "static/media/wave.e11586df.svg";